module.exports = __webpack_public_path__ + "static/media/sf-test-12.c3f0fb90.mp3";